import toast from "react-hot-toast";
import usePut from "../usePut";

const useDuplicateSalaryTemplate = ({ onDuplicate }) => {
  const { handleAuth: duplicateReq } = usePut({
    url: "template-salary-structure/duplicate",
    refreshUrl: ["template-salary-structure/list"],
    onSuccess: (data) => {
      toast.success("Template duplicated successfully");
      if (onDuplicate) onDuplicate(data);
    },
    onError: (error) => {
      toast.error("Failed to duplicate template: " + error?.message);
    },
  });
  const isDuplicating = duplicateReq.isLoading;

  const duplicateTemplate = (templateId, template) => {
    duplicateReq.mutate({
      old_template_id: templateId,
      name: template.name + " Copy",
    });
  };

  return { isDuplicating, duplicateTemplate };
};

export default useDuplicateSalaryTemplate;
